module.exports = __webpack_public_path__ + "static/media/robert-daponte.430831e3.md";